const headerFindSign = (data, operation) => {

  let result = { ...data }

  const value = result[operation.targetField]
  if (value > 0) {
    result.isPositive = true
    result.isNegative = false
  } else if (value < 0) {
    result.isPositive = false
    result.isNegative = true
  }

  return result
}

export default headerFindSign